/* eslint-disable no-case-declarations */
/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TabPanel, CardTest } from '@orientaction/components';
import { MarginContainer } from '@orientaction/commons';
import { useCategoryTest, useTest } from '@orientaction/hooks';
import FirstEtage from './ViewTest/FirstEtage';
import SecondEtage from './ViewTest/SecondEtage';
import React, { FC } from 'react';
import { useStyles } from './style';

interface ITabPannelAdminTest {
  tabs: number;
  loading: boolean;
  searchFilter?: string;
}

const TabPannelAdminTest: FC<ITabPannelAdminTest> = ({ tabs, loading, searchFilter }) => {
  const classes = useStyles();

  const { disabledTests, archivedTests, tests } = useTest();

  const { list } = useCategoryTest();

  const filterByTitle = (items: any[]) => {
    if (!searchFilter) return items;
    return (items || []).filter((test: any) =>
      test.attributes?.title?.toLowerCase().includes(searchFilter.toLowerCase())
    );
  };

  const filteredAllTests = filterByTitle(tests);
  const filteredDisabledTests = filterByTitle(disabledTests);
  const filteredArchivedTests = filterByTitle(archivedTests);

  const filteredList = React.useMemo(() => {
    const normalizedList = (list || []).map((category: any) => ({
      ...category,
      contentList: category.contentList || [],
    }));

    if (!searchFilter) {
      return normalizedList;
    }

    return normalizedList
      .map((category: any) => ({
        ...category,
        contentList: category.contentList.filter((test: any) =>
          test.title?.toLowerCase().includes(searchFilter.toLowerCase())
        ),
      }))
      .filter((category: any) => category.contentList.length > 0);
  }, [searchFilter, list]);
  return (
    <MarginContainer>
      {loading ? (
        <div className={classes.bodycenter}>
          <CircularProgress color="inherit" />
        </div>
      ) : (
        <>
          <TabPanel value={tabs} index={0}>
            <Grid container={true} spacing={1}>
              {Array.isArray(filteredAllTests) && filteredAllTests.length > 0 ? (
                filteredAllTests.map((test: any) => (
                  <Grid item={true} xs={4} key={test.id}>
                    <CardTest
                      key={test.id}
                      id={test.id}
                      isArchived={test.attributes?.isArchived}
                      isDesabled={test.attributes?.isDesabled}
                      title={test.attributes?.title}
                      description={test.attributes?.description}
                      image={test.attributes?.image}
                      thumbnail={test.attributes?.thumbnail}
                      time={test.attributes?.time}
                      category={test.category}
                      showStatusChip={true}
                      slugEn={test.attributes?.slugEn}
                    />
                  </Grid>
                ))
              ) : (
                <div className={classes.bodycenter}>Aucun test disponible</div>
              )}
            </Grid>
          </TabPanel>

          <TabPanel value={tabs} index={1}>
            {(filteredList?.reduce(
              (acc: number, cur: any) => acc + (cur.contentList?.length || 0),
              0
            ) ?? 0) > 0 ? (
              filteredList.map((category: any, i: number) => {
                if (!category?.contentList || !category.contentList.length) {
                  return <div key={category.id} />;
                }

                return (
                  <div key={category.id}>
                    <MarginContainer>
                      <Typography variant="h4" data-cy={`default-category-${i}`}>
                        {category.name}
                      </Typography>
                    </MarginContainer>

                    <MarginContainer>
                      <div className={classes.cardContent}>
                        <FirstEtage listFirstEtape={category.contentList} />

                        <SecondEtage listSecondEtape={category.contentList} />

                        <br className={classes.both} />
                      </div>
                    </MarginContainer>
                  </div>
                );
              })
            ) : (
              <div className={classes.bodycenter}>Aucun test disponible</div>
            )}
          </TabPanel>

          <TabPanel value={tabs} index={2}>
            <Grid container={true} spacing={1}>
              {Array.isArray(filteredDisabledTests) && filteredDisabledTests.length > 0 ? (
                filteredDisabledTests.map((test: any) => {
                  return (
                    <Grid item={true} xs={4} key={test.id}>
                      <CardTest
                        status="desactive"
                        key={test.id}
                        id={test.id}
                        isArchived={test.attributes.isArchived}
                        isDesabled={test.attributes.isDesabled}
                        title={test.attributes.title}
                        description={test.attributes.description}
                        image={test.attributes.image}
                        thumbnail={test.attributes.thumbnail}
                        time={test.attributes.time}
                        category={test.category}
                        slugEn={test.attributes?.slugEn}
                      />
                    </Grid>
                  );
                })
              ) : (
                <div className={classes.bodycenter}>Aucun test désactivé</div>
              )}
            </Grid>
          </TabPanel>

          <TabPanel value={tabs} index={3}>
            <Grid container={true} spacing={1}>
              {Array.isArray(filteredArchivedTests) && filteredArchivedTests.length > 0 ? (
                filteredArchivedTests.map((test: any) => {
                  return (
                    <Grid item={true} xs={4} key={test.id}>
                      <CardTest
                        status="archive"
                        key={test.id}
                        id={test.id}
                        isArchived={test.attributes.isArchived}
                        isDesabled={test.attributes.isDesabled}
                        title={test.attributes.title}
                        description={test.attributes.description}
                        image={test.attributes.image}
                        thumbnail={test.attributes.thumbnail}
                        time={test.attributes.time}
                        category={test.category}
                        slugEn={test.attributes?.slugEn}
                      />
                    </Grid>
                  );
                })
              ) : (
                <div className={classes.bodycenter}>Aucun test archivé</div>
              )}
            </Grid>
          </TabPanel>
        </>
      )}
    </MarginContainer>
  );
};

export default TabPannelAdminTest;
